import { FC } from "react";
import { Box, Typography } from "@mui/material";
import __ from "src/utils/Translations";
import {
  Avatar,
  PresenceIndicator,
  PresenceInformation,
} from "@benefit-systems/hr-tools-ui";

interface IEmployeeAvatar {
  name: string;
  fk: string;
  initials: string;
  position: string | null;
  area: string | null;
  avatar: string;
  presenceInformation?: PresenceInformation;
}

const EmployeeAreaAvatar: FC<IEmployeeAvatar> = ({
  name,
  fk,
  initials,
  position,
  area,
  avatar,
  presenceInformation,
}) => (
  <Box
    sx={{
      padding: "12px 16px",
      display: "flex",
      alignItems: "center",
    }}
  >
    <PresenceIndicator status={presenceInformation?.status}>
      <Avatar src={avatar || undefined}>{initials}</Avatar>
    </PresenceIndicator>
    <Box
      component="span"
      sx={{ display: "flex", flexDirection: "column", gap: 0.5, ml: 1 }}
    >
      {name && (
        <Typography
          sx={{
            fontWeight: "fontWeightMedium",
            fontSize: "14px",
            lineHeight: "12px",
          }}
        >
          {name}
          <Box
            component="span"
            sx={{
              fontSize: "14px",
              lineHeight: "12px",
              fontWeight: 100,
              color: "#838C96",
            }}
          >
            {` `}
            {`(FK: ${fk})`}
          </Box>
        </Typography>
      )}

      {position && (
        <Typography
          sx={{
            fontSize: "12px",
            lineHeight: "10px",
            fontWeight: 100,
            color: "#838C96",
          }}
        >
          {__(`${position}`)}
        </Typography>
      )}

      {area && (
        <Typography
          sx={{
            fontSize: "12px",
            lineHeight: "10px",
            fontWeight: 100,
            color: "#838C96",
          }}
        >
          {__(`${area}`)}
        </Typography>
      )}
    </Box>
  </Box>
);

export default EmployeeAreaAvatar;
